<template>
  <div id="app">
    <div class="container">
      <input class="user-text" type="text" />
      <a href="#" class="set-text">Click to set text</a>
    </div>
    <TypingBox
      v-if="!editing"
      :content="text"
      @dblclick="editing = true"
      @focus="activated = true"
      @click="boxClicked"
      :activated="activated"
      @keyEvent="updateStat"
    />
    <textarea
      class="typing-box"
      v-else
      v-model="textInput"
      @focusout="updateText"
    ></textarea>
    <div class="stat" :class="{ left: atPageBottom }">
      <!--      Delta time: {{ stat.delta }} <br>-->
      <!--      Keys: "{{ stat.previousKey + stat.newKey }}" <br>-->
      <!--      Charset: <span v-for="ch, i in stat.charSet" :key="i">"{{ ch }}" </span> <br>-->
      <h3>Time between keys</h3>
      <table class="stat-table .time-matrix">
        <thead>
          <th>/</th>
          <th v-for="(ch, i) in stat.charSet" :key="i">
            <div class="cell">{{ ch }}</div>
          </th>
        </thead>
        <tbody>
          <tr v-for="(ch, i) in stat.charSet" :key="i">
            <th>
              <div class="cell">{{ ch }}</div>
            </th>
            <td
              v-for="(tgt, j) in stat.charSet"
              :key="`${i}-${j}`"
              :style="{ 'background-color': calcTimeMatrixColor(ch, tgt) }"
            ></td>
          </tr>
        </tbody>
      </table>
      <br />
    </div>
    <div class="stat" :class="{ right: atPageBottom }">
      <!--      Delta time: {{ stat.delta }} <br>-->
      <!--      Keys: "{{ stat.previousKey + stat.newKey }}" <br>-->
      <!--      Charset: <span v-for="ch, i in stat.charSet" :key="i">"{{ ch }}" </span> <br>-->
      <h3>Error counts</h3>
      <table class="stat-table .time-matrix">
        <thead>
          <th>/</th>
          <th v-for="(ch, i) in stat.charSet" :key="i">
            <div class="cell">{{ ch }}</div>
          </th>
        </thead>
        <tbody>
          <tr v-for="(ch, i) in stat.charSet" :key="i">
            <th>
              <div class="cell">{{ ch }}</div>
            </th>
            <td
              v-for="(tgt, j) in stat.charSet"
              :key="`${i}-${j}`"
              :style="{ 'background-color': calcErrorMatrixColor(ch, tgt) }"
            ></td>
          </tr>
        </tbody>
      </table>
      <br />
    </div>
  </div>
</template>

<script>
import { reactive } from 'vue'
import TypingBox from './components/TypingBox.vue'
import { constants } from "@/constant";
import interpolate from 'color-interpolate'

function jsonStrToMap(jsonStr) {
  return new Map(jsonStr);
}

function jsonStrToSet(jsonStr) {
  return new Set(jsonStr);
}

export default {
  name: 'App',
  components: {
    TypingBox
  },
  created() {
    if (localStorage.getItem('textToType') !== undefined) {
      this.text = localStorage.getItem('textToType')
    }
    this.textInput = this.text
    if (localStorage.getItem('stat') !== undefined) {
      const stat = JSON.parse(localStorage.getItem('stat'))
      console.log(stat)
      if (stat && stat.charSet) {
        this.stat.charSet = new reactive(jsonStrToSet(stat.charSet))
        this.stat.deltaTimeMatrix = new reactive(jsonStrToMap(stat.deltaTimeMatrix))
        this.stat.errorCountMatrix = new reactive(jsonStrToMap(stat.errorCountMatrix))
      }
    }
  },
  setup() {
    return {
      constants: constants
    }
  },
  data() {
    return {
      text: "",
      textInput: "",
      editing: false,
      activated: false,
      atPageBottom: false,
      stat: {
        delta: -1,
        previousKeystrokeTimestamp: 0,
        previousKey: "",
        newKey: "",
        expectedKey: "",
        momentum: 0.9,
        charSet: reactive(new Set()),
        deltaTimeMatrix: reactive(new Map()),
        errorCountMatrix: reactive(new Map())
      }
    }
  },
  mounted() {
    window.addEventListener('click', this.boxBlur)
    window.addEventListener('scroll', this.scrollEvent)
    setInterval(this.saveStat.bind(this), 30 * 1000)
    this.text = constants.DEFAULT_TEXT
    document.querySelector('.set-text').addEventListener('click', this.setText)
  },
  methods: {
    calcErrorMatrixColor(keyA, keyB) {
      const result = this.stat.errorCountMatrix.get(this.makePair(keyA, keyB))
      if (result === undefined)
        return '#ffffff77'
      else
        return this.mapColor(result, 0, constants.MAX_ERROR_COUNT)
    },
    calcTimeMatrixColor(keyA, keyB) {
      const result = this.stat.deltaTimeMatrix.get(this.makePair(keyA, keyB))
      if (result === undefined)
        return '#ffffff77'
      else
        return this.mapColor(result, 0, constants.MAX_KEYSTROKE_INTERVAL / 1000)
    },
    colorMappingFunction(t) { // time t should be with in [0, 1] and output [0, 1]
      return t ** 0.25 // concave down
    },
    mapColor(value, lo, hi) {
      const range = hi - lo
      value -= lo
      value /= range
      const colorMap = interpolate(['#a0ffa0', '#ff8585'])
      return colorMap(this.colorMappingFunction(value))
    },
    getChars() {
      return Object.keys(this.stat.charSet)
    },
    updateStat({ delta, previousKeystrokeTimestamp, previousKey, newKey, expectedKey }) {
      this.stat.previousKeystrokeTimestamp = previousKeystrokeTimestamp
      this.stat.delta = delta
      this.stat.previousKey = previousKey
      this.stat.newKey = newKey
      this.stat.expectedKey = expectedKey
      if (newKey !== "")
        this.stat.charSet.add(newKey)
      this.updateMatrices(previousKey, newKey, expectedKey, delta)
    },
    updateText() {
      this.editing = false
      this.text = this.textInput
      localStorage.setItem('textToType', this.text)
      console.log(this.$refs.box.$root)
      this.$refs.box.$el.focus()
    },
    boxClicked(event) {
      event.stopPropagation()
      this.activated = true
    },
    boxBlur(event) {
      event.stopPropagation()
      this.activated = false
    },
    makePair(a, b) {
      return JSON.stringify([a, b])
    },
    updateMatrices(previousKey, newKey, expectedKey, delta) {
      if (previousKey === "" || newKey === "" || expectedKey === "" || delta <= 0)
        return

      const pair = this.makePair(previousKey, newKey)
      console.log(pair)

      if (newKey === expectedKey) { // correct, update delta time
        if (!this.stat.deltaTimeMatrix.has(pair))
          this.stat.deltaTimeMatrix.set(pair, delta)
        else
          this.stat.deltaTimeMatrix.set(pair, (1 - this.stat.momentum) * delta + this.stat.momentum * this.stat.deltaTimeMatrix.get(pair))
        console.log('dT', this.stat.deltaTimeMatrix)
      } else { // incorrect, update error counts
        if (!this.stat.errorCountMatrix.has(pair))
          this.stat.errorCountMatrix.set(pair, 1)
        else
          this.stat.errorCountMatrix.set(pair, this.stat.errorCountMatrix.get(pair) + 1)
        console.log('eC', this.stat.errorCountMatrix)
      }
    },
    saveStat() {
      console.log('saving statistics')
      localStorage.setItem('stat', JSON.stringify(this.stat, (k, x) => x instanceof Set || x instanceof Map ? [...x] : x))
    },
    scrollEvent() {
      const box = document.querySelector('.typing-box')
      const rect = box.getBoundingClientRect()
      const bottom = box.offsetTop + rect.height
      this.atPageBottom = window.scrollY < bottom - window.screen.height
    },
    setText() {
      this.text = document.querySelector('input.user-text').value
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 60px;
  gap: 50px;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
}

.typing-box {
  position: relative;
  font-family: monospace;
  border: 1px solid gray;
  white-space: pre-wrap;
  text-align: left;
  width: 80%;
  font-size: 2rem;
  margin-left: auto;
  margin-right: auto;
  text-wrap: normal;
  padding: 1em;
  background-color: #ffffffaa;
  z-index: 10;

  &::before {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-attachment: fixed;
    background-color: #ffffff11;
    backdrop-filter: blur(1px);
    z-index: -3;
  }
}

.stat {
  text-align: left;
  position: static;
  &.left {
    position: fixed;
    left: 10px;
    top: 10px;
  }

  &.right {
    position: fixed;
    top: 10px;
    right: 10px;
  }

  // tab-index: 0;
  user-select: none;
  // user-focus: none;
  z-index: 0;
}

.stat-table {
  filter: opacity(0.9);
  border-collapse: collapse;

  th + th {
    writing-mode: vertical-lr;
    text-orientation: upright;
  }

  th,
  td {
    padding: 0;
    margin: 0;
    height: 10px;
    width: 10px;
    position: relative;
    .cell {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &:hover {
      filter: brightness(90%);
      //background-color: yellow;
    }
  }
}

.container {
  display: flex;
  flex-direction: row;
  gap: 2em;
  justify-content: center;
  align-items: center;
}
</style>
